<template>
  <div>
    <div
      v-for="(record, key) in value"
      :key="key"
    >
      <div
        v-if="record.change"
        style="font-weight: bolder; font-size: smaller"
      >
        {{ record.change.type === 'SMIRKS' ? 'Transformation' : record.change.text }}
      </div>
      <div
        v-else-if="record.parent"
        style="font-weight: bolder; font-size: smaller"
      >
        Parent
      </div>
      <div
        v-else-if="record.child"
        style="font-weight: bolder; font-size: smaller"
      >
        Component extracted
      </div>
      <div
        v-else
        style="font-weight: bolder; font-size: smaller"
      >
        Original
      </div>

      <div>
        <img
          :id="`${record.ordinal}-${record.chemical.id}`"
          :src="`${STDIZER_URL}/render?smiles=${encodeURIComponent(record.chemical.smiles)}`"
          alt=""
          style="width: 250px; height: 150px"
        />
        <ChemPopover
          :chemical="record.chemical"
          :target="`${record.ordinal}-${record.chemical.id}`"
          source="stdizer"
        />

        <img
          v-if="record.change && record.change.type === 'SMIRKS'"
          :src="`${STDIZER_URL}/render?smirks=${encodeURIComponent(record.change.value)}`"
          alt=""
          style="width: 300px; height: 150px; position: absolute; right: 10px"
        />
      </div>

      <div
        v-if="showDetails"
        style="font-size: smaller"
      >
        <div
          v-for="prop in ['inchi', 'inchiKey', 'smiles']"
          :key="`org-${prop}`"
          class="mb-1"
        >
          {{ record.chemical[prop] }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChemPopover from '@/components/chemical/ChemPopover/ChemPopover.vue'
import { STDIZER_URL } from '@/main'

export default {
  components: { ChemPopover },

  props: {
    value: {
      type: Array,
      required: true,
    },
    showDetails: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    STDIZER_URL() {
      return STDIZER_URL
    },
  },
}
</script>

<style scoped></style>
